// extracted by mini-css-extract-plugin
export default {"container":"ApplicantCard_container__PRUuL","nameWrap":"ApplicantCard_nameWrap__RiW6D","newTag":"ApplicantCard_newTag__GorkS","detailsWrap":"ApplicantCard_detailsWrap__rFicR"};